module.exports = __webpack_public_path__ + "img/shichang-active.0a618e58.png";